import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HuanoCaramelLatte = () => (
  <ArticleWrapper articleId="huano_caramel_latte">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Huano Caramel Latte</h1>
      {/* Add your Huano Caramel Latte article content here */}
      <p>This is a placeholder article for the Huano Caramel Latte switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HuanoCaramelLatte;
